// src/Pages/Articles/articlesData.js

export const articlesData = [
  {
    id: 1,
    title: "Why Workplace Refreshments Matter More Than Ever",
    slug: "why-workplace-refreshments-matter",
    author: "UrbanBrew Editorial Team",
    date: "2025-11-15",
    image: "/assets/img/webp/blog-productivity-hero.webp",
    imageAlt:
      "UrbanBrew workplace refreshment setup supporting team wellbeing and productivity",
    summary:
      "Discover how planned refreshment services enhance workplace wellbeing, boost productivity, and transform visitor experience.",
    content: `
      <h2 class="text-2xl font-serif mb-4 text-[#22429a]">Why Workplace Refreshments Matter More Than Ever</h2>

      <p class="mb-4 text-[#22429a] leading-[28px]">
        In today's dynamic workplaces, employees expect more than just a desk and a laptop. 
        They seek comfort, convenience, and small moments of delight that make the workday smoother. 
        One of the simplest yet most impactful ways to elevate workplace wellbeing is through a 
        thoughtfully curated refreshment program.
      </p>

      <h3 class="text-xl font-semibold mt-6 mb-3 text-[#22429a]">
        1. A Better Workday Starts With Better Breaks
      </h3>
      <p class="mb-4 text-[#22429a] leading-[28px]">
        Coffee breaks are no longer just breaks—they are social anchors. 
        Teams bond, exchange ideas, and reset mentally. A well-placed, reliable vending setup 
        ensures teams have instant access to energizing beverages and quick snacks.
      </p>

      <h3 class="text-xl font-semibold mt-6 mb-3 text-[#22429a]">
        2. Visitors Remember the Experience
      </h3>
      <p class="mb-4 text-[#22429a] leading-[28px]">
        Whether it's prospective clients, partners, or interview candidates—your refreshment station 
        silently communicates your brand's culture. A premium bean-to-cup coffee or a simple tea 
        served fresh can create lasting positive impressions.
      </p>

      <h3 class="text-xl font-semibold mt-6 mb-3 text-[#22429a]">
        3. Convenience = Productivity
      </h3>
      <p class="mb-4 text-[#22429a] leading-[28px]">
        When refreshment options are easily accessible, employees save time otherwise spent 
        stepping out. This leads to higher productivity and better focus throughout the day.
      </p>

      <p class="mt-8 font-medium text-[#22429a]">
        UrbanBrew continues to help businesses build thoughtful refreshment experiences that 
        uplift teams and delight visitors—because small moments drive big impact.
      </p>
    `,
  },

  {
    id: 2,
    title: "How Refreshments Influence Team Engagement",
    slug: "refreshments-influence-team-engagement",
    author: "UrbanBrew Editorial Team",
    date: "2025-11-16",
    image: "/assets/img/webp/blog-automation-hero.webp",
    imageAlt:
      "Smart vending and refreshment automation for engaged workplace teams",
    summary:
      "Learn how offering quality refreshments increases employee engagement and promotes a positive workplace culture.",
    content: `
      <h2 class="text-2xl font-serif mb-4 text-[#22429a]">How Refreshments Influence Team Engagement</h2>

      <p class="mb-4 text-[#22429a] leading-[28px]">
        Engagement thrives in environments where employees feel cared for. 
        Something as simple as a dependable tea or coffee counter can significantly uplift team morale.
      </p>

      <h3 class="text-xl mt-6 mb-3 font-semibold text-[#22429a]">
        Micro-Breaks Fuel Macro Productivity
      </h3>
      <p class="mb-4 text-[#22429a] leading-[28px]">
        Short, meaningful breaks help employees reset and return to work with higher clarity. 
        A well-stocked refreshment station ensures these resets are enjoyable and rejuvenating.
      </p>

      <h3 class="text-xl mt-6 mb-3 font-semibold text-[#22429a]">
        A Sense of Belonging
      </h3>
      <p class="mb-4 text-[#22429a] leading-[28px]">
        Shared coffee moments foster a sense of community and belonging—key ingredients of team engagement. 
        Spaces that encourage such interactions result in happier, more connected teams.
      </p>
    `,
  },

  {
    id: 3,
    title: "Creating a Hospitality-First Office Culture",
    slug: "creating-hospitality-first-office-culture",
    author: "UrbanBrew Editorial Team",
    date: "2025-11-17",
    image: "/assets/img/webp/blog-experience-hero.webp",
    imageAlt: "Visitor hospitality coffee service in a modern office environment",
    summary:
      "Great hospitality is not only for hotels—learn how offices can adopt the same mindset with simple refreshment strategies.",
    content: `
      <h2 class="text-2xl font-serif mb-4 text-[#223bac]">Creating a Hospitality-First Office Culture</h2>

      <p class="mb-4 text-[#22429a] leading-[28px]">
        Offices that treat employees and guests with warmth stand out instantly. 
        Hospitality begins with the small details—comfort, cleanliness, and refreshment access.
      </p>

      <h3 class="text-xl text-[#22429a] mt-6 mb-3 font-semibold">
        Professionalism in Every Cup
      </h3>
      <p class="mb-4 text-[#22429a]/80 leading-[28px]">
        Offering consistent beverage quality demonstrates that your business values 
        professionalism and attention to detail.
      </p>

      <h3 class="text-xl mt-6 mb-3 font-semibold text-[#22429a]">
        The Visitor Experience Advantage
      </h3>
      <p class="mb-4 leading-[28px] text-[#22429a]">
        Guests notice everything—from the waiting area to the service culture. 
        A premium coffee, chilled water station, or light snacks can elevate your brand presence effortlessly.
      </p>
    `,
  },
];
